// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_KL_","cls2":"ProfileDropdown-cls2_Yx0 ProfileDropdown-cls1_KL_"};